import { Box, Typography } from '@mui/material';
import Summary from 'components/summary';
import { Info } from 'lucide-react';
import Mui from 'materials';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import titleCase from 'utils/title-case';
import { useCalibrationState } from '../../../context/calibration-context';
import { CalibrationState } from '../../../types/calibration-state.enum';

const PAGE_NAME_ID = 'bluViuNutrition.calibrations.editCalibration.calibrationStatistics';

const SimpleCalibrationStatistics: React.FC<{}> = () => {
  const {
    simpleCalibrationQuery: { data },
  } = useCalibrationState();

  if (!data) return;

  return (
    <Summary
      items={[
        {
          header: (
            <Typography>
              <FormattedMessage id={`${PAGE_NAME_ID}.status.title`} />
            </Typography>
          ),
          text:
            data.state === CalibrationState.MODIFIED ? (
              <Box display={'flex'} flexDirection={'row'} gap={2}>
                {titleCase(data.state)}
                <Mui.Tooltip title={<FormattedMessage id={`${PAGE_NAME_ID}.status.modifiedTooltip`} />} arrow>
                  <Info />
                </Mui.Tooltip>
              </Box>
            ) : (
              titleCase(data.state)
            ),
        },
        {
          header: (
            <Typography>
              <FormattedMessage id={`${PAGE_NAME_ID}.weightGain.title`} />
            </Typography>
          ),
          text: <FormattedNumber value={data.growthCoefficient} />,
        },
        {
          header: (
            <Typography>
              <FormattedMessage id={`${PAGE_NAME_ID}.feedIntake.title`} />
            </Typography>
          ),
          text: <FormattedNumber value={data.feedIntakeCoefficient} />,
        },
      ]}
    />
  );
};

export default React.memo(SimpleCalibrationStatistics);
